import { ProfileDetailUserDataSubAccounts } from '@/components/custom/profileDetailUserData';
import { UserProfileDetailsHeader } from '@/components/custom/userProfileDetails';
import { Loader, NoPermission, PanelInfo } from '@/components/custom';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { SecuredComponent } from '@/components/hoc';
import { Podcast } from 'lucide-react';
import { useUser } from '../hooks';

const BodyPage = () => {

	const { userId, isLoadingUserData, userData } = useUser();

	if (isLoadingUserData) {
		return (
			<div className='my-10'>
				<Loader className='my-10' />
			</div>
		);
	}

	if (!userData || !userId) {
		return (
			<PanelInfo
				title={'Cet utilisateur n\'existe pas'}
				description={
					<div className='flex space-x-1'>
						<span>
							Aucun utilisateur ne possède l'identifiant
						</span>
						<span className='font-semibold text-purple-600'>
							{userId}
						</span>
						<span>
							dans notre système.
						</span>
					</div>
				}
				className='py-10 md:py-26 border-none'
				icon={Podcast} />
		);
	}

	return (
		<div className={`flex flex-col gap-4`}>
			<div className='flex flex-col space-y-3'>
				<UserProfileDetailsHeader
					hideSeparator={!(
						userData?.verifications?.bio ||
						userData.verifications?.id?.photo ||
						(userData.pictures?.length ?? 0) !== 0)
					}
					userData={userData} />
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.USERS_SUB_ACCOUNTS]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.USERS_SUB_ACCOUNTS]} />}>
					<ProfileDetailUserDataSubAccounts userId={userData._id} />
				</SecuredComponent>
			</div>
		</div>
	);

};

export default BodyPage;
